import { useEffect, useState } from "react";
import axios from "axios";
import Breadcrumb from "../components/layout/breadcrumb";
import InsertionCard from "../components/InsertionCard";



export default function Esplora(){
    let [typology, setTypology] = useState([]);
    let [insertions, setInsertions] = useState([]);
    let [insertionNumbers, setInsertionNumbers] = useState(0);
    let [pageLimit, setPageLimit] = useState(12);
    let [currentPage, setCurrentPage] = useState(1);
    let [lastPage, setLastPage] = useState(1);

   

    useEffect(() => {
        axios.get("http://109.230.235.211/api/get-tipology").then((res) => setTypology(res.data));
    },[]);


    useEffect(() => {
        axios.get("http://109.230.235.211/api/get-ad/" + pageLimit+"?paginate=1&page="+currentPage).then((res) => {
            setInsertions(res.data.insertions);
            setInsertionNumbers(res.data.insertions.length * res.data.pagination.last);

            setCurrentPage(res.data.pagination.currentPage);
            setLastPage(res.data.pagination.last);
        });
    },[currentPage]);


    let pages = [];

    for(let i = 1; i<=lastPage; i++){
        pages.push(i);
    }

    function changePage(e){
        e.preventDefault();
        let page = e.currentTarget.getAttribute("data-value");
        
        setCurrentPage(page)

    }

    return (
        <>
            <Breadcrumb location="Esplora" />

            <div class="ltn__product-area ltn__product-gutter mb-120">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-8">
                            
                            <div class="tab-content">
                                <div class="tab-pane fade active show" id="liton_product_grid">
                                    <div class="ltn__product-tab-content-inner ltn__product-grid-view">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                
                                                <div class="ltn__search-widget mb-30">
                                                    <form action="#"  data-form-type="">
                                                        <input type="text" name="search" placeholder="Cerca per Comune o Indirizzo"  data-form-type=""/>
                                                        <button type="submit"  data-dashlane-label="true" data-form-type=""><i class="fas fa-search"></i></button>
                                                    </form>
                                                </div>
                                            </div>
                                            
                                            
                                            {
                                                insertions.map( (data) => {
                                                    return <InsertionCard info={data}/>;
                                                })
                                            }


                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="ltn__pagination-area text-center">
                                <div class="ltn__pagination">
                                    <ul>
                                        <li><a href="#" data-value={currentPage - 1} onClick={changePage}><i class="fas fa-angle-double-left"></i></a></li>
                                        {
                                            currentPage &&
                                            pages.map((e) => {
                                                return (<><li class={(e == currentPage ? 'active' : '') }><a data-value={e} onClick={changePage} href="#">{e}</a></li></>);
                                            })
                                        }
                                        <li><a href="#" data-value={currentPage + 1} onClick={changePage}><i class="fas fa-angle-double-right"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <aside class="sidebar ltn__shop-sidebar ltn__right-sidebar">
                                <h3 class="mb-10 animated fadeIn">Filtri</h3>
                                <label class="mb-30"><small>Abbiamo trovato {insertionNumbers} annunci</small></label>
                                
                                <div class="widget ltn__menu-widget">
                                    <h4 class="ltn__widget-title">Tipologia</h4>
                                    <ul>
                                        {
                                            typology.map( (data) => {
                                                return (
                                                    <>
                                                        <li>
                                                            <a href="shop-right-sidebar.html">
                                                                <label class="checkbox-item">{data.name}
                                                                    <input type="checkbox" name="typology[]" value="{data.id}"/>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                                <span class="categorey-no"></span>
                                                            </a>
                                                        </li>
                                                    </>
                                                );
                                            })
                                        }
                                        
                                    </ul>

                                    <hr/>
                                    
                                    <h4 class="ltn__widget-title">Contratto</h4>
                                    <ul>
                                        <li>
                                            <label class="checkbox-item">Affitto
                                                <input type="checkbox" name="contract[]" value="1" />
                                                <span class="checkmark"></span>
                                            </label>
                                            <span class="categorey-no"></span>
                                        </li>
                                        <li>
                                            <label class="checkbox-item">Vendita
                                                <input type="checkbox" name="contract[]" value="2"/>
                                                <span class="checkmark"></span>
                                            </label>
                                            <span class="categorey-no"></span>
                                        </li>
                                        
                                    </ul>
                                    
                                    
                                    <hr/>
                                    
                                    <div class="widget--- ltn__price-filter-widget">
                                        <h4 class="ltn__widget-title ltn__widget-title-border---">Filtra per prezzo</h4>
                                        <div class="price_filter">
                                            <div class="price_slider_amount" data-form-type="shopping_basket">
                                                <input type="submit" value="Range:"/> 
                                                <input type="text" class="amount" name="price" placeholder="Add Your Price" data-form-type="other"/> 
                                            </div>
                                            <div class="slider-range ui-slider ui-slider-horizontal ui-widget ui-widget-content ui-corner-all"><div class="ui-slider-range ui-widget-header ui-corner-all" style={{left: "0%", width: "29.2929%"}}></div><span class="ui-slider-handle ui-state-default ui-corner-all" tabindex="0" style={{left: "0%"}}></span><span class="ui-slider-handle ui-state-default ui-corner-all" tabindex="0" style={{left: "29.2929%"}}></span></div>
                                        </div>
                                    </div>
                                    
                                </div>
                                
                                
              
         
                            </aside>
                        </div>
                    </div>
                </div>
            </div>
         

        </>
    );
    
}